import classnames from 'classnames';
import React, { useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import Checkbox from '@ao-internal/components-react/lib/Checkbox';

import { useIsBelowMobileSmallOnly } from '../../../hooks/mediaQueries';
import { isTouchScreenDevice } from '../../../utilities/lister-utilities';
import BrandLogoImage from './BrandLogoImage';

const TrendingBrandsFacet = ({
	facet,
	idx,
	itemsInCarousel,
	isReady,
	handleChange,
}) => {
	const [hovered, setHovered] = useState(false);

	const isTouchScreen = isTouchScreenDevice();

	const isBelowMobileSmallOnly = useIsBelowMobileSmallOnly();

	const { Url, Name, Total, Selected } = facet;

	return (
		<div
			className="py-2 h-full"
			style={{
				paddingRight: idx === itemsInCarousel - 1 ? '2px' : '0px',
			}}>
			<a
				href={Url}
				role="button"
				className={classnames(
					'flex flex-col items-center h-full border border-solid py-2 px-4 hover:shadow-2dp shadow-none',
					{
						'border-gray-20': !isReady,
						'border-gray-50': isReady,
						'border-cta-actionhover': isReady && Selected,
						'selected-or-hovered': Selected || hovered,
					}
				)}
				onMouseEnter={() => !isTouchScreen && setHovered(true)}
				onMouseLeave={() => !isTouchScreen && setHovered(false)}
				onClick={(evt) => handleChange(evt, facet, idx)}>
				<div className="flex items-center pb-2 pt-2" style={{ height: '50%' }}>
					<BrandLogoImage Name={Name} isReady={isReady} />
				</div>

				{isReady ? (
					<Checkbox
						checked={Selected}
						className="ml-1 pt-1 flex items-center "
						style={{ height: '50%' }}
						data-testid="trendingbrand_checkbox"
						name={Name}
						onChange={(evt) => handleChange(evt, facet, idx)}>
						<span
							className={classnames('text-title-sm text-cta-action', {
								'text-cta-actionhover': hovered || Selected,
								'text-xs': isBelowMobileSmallOnly,
							})}>
							{Name}
						</span>
						<span
							style={{ paddingLeft: '2px' }}
							className={classnames(
								'text-title-sm text-cta-action font-regular',
								{
									'text-cta-actionhover': hovered || Selected,
									'text-xs': isBelowMobileSmallOnly,
								}
							)}>
							({Total})
						</span>
					</Checkbox>
				) : (
					<Skeleton width={100} />
				)}
			</a>
		</div>
	);
};

export default TrendingBrandsFacet;
